<button class="btn m-2 mainColor text-white" style="font-size: 14px;" (click)="generateReport()">
    <ng-container *ngIf="!loadingReport;else spinner">
        {{ "historic.generate_report" | translate }}
    </ng-container>
    <ng-template #spinner>
        <fa-icon icon="spinner" [spin]="true"></fa-icon>
    </ng-template>
</button>